import { bffApi } from "../../../autogen/bff-api";
import { useApiError } from "../../errors/useApiError";
import { useAppDispatch } from "../../redux/hooks";

export const useDocumentDownloader = () => {
  const dispatch = useAppDispatch();
  const displayer = useApiError();

  const downloadSignedDocument = async (documentId: string): Promise<string | null> => {
    const postRequestResult = await dispatch(
      bffApi.endpoints.getSignedDocumentDownloadLink.initiate({
        docId: documentId,
      })
    )
      .unwrap()
      .catch((e) => {
        displayer.trigger(e);
        throw e;
      });
    return postRequestResult.url;
  };

  const downloadDocument = async (documentId: string): Promise<string> => {
    const postRequestResult = await dispatch(
      bffApi.endpoints.getDownloadLink.initiate({
        docId: documentId,
      })
    )
      .unwrap()
      .catch((e) => {
        displayer.trigger(e);
        throw e;
      });
    return postRequestResult.url;
  };

  const getDownloadLink = async (documentId: string, isSignedDocument: boolean): Promise<string | null> => {
    if (isSignedDocument) {
      return await downloadSignedDocument(documentId);
    } else {
      return await downloadDocument(documentId);
    }
  };

  return {
    getDownloadLink,
  };
};
